import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import {
  Button,
  message,
  Radio,
  Modal,
  ConfigProvider,
  Avatar,
  Divider,
  Table,
} from "antd";
import {
  DeleteConfirmationModal,
  OKConfirmationModal,
} from "../Helper/DeleteConfirmationModal";
import { LayoutData } from "../Structur/Aconlayout";
import { useQuery } from "@tanstack/react-query";
import { PendingComp } from "../Helper/ProgressComp";

export const AlleUsers = () => {
  const { user, checkRole, windowWidth, apiBaseUrl, deleteUser,logoutLogin } = LayoutData();
  const [redirectToAccount, setRedirectToAccount] = useState(false);
  const [rowData, setRowData] = useState(null);
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();
  const [forceRender, setForceRender] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [userNameToDelete, setUserNameToDelete] = useState("");
  const [columnWidth, setColumnWidth] = useState(windowWidth > 450 ? 85 : 1);
  const [url1, setUrl1] = useState("");
  const [url2, setUrl2] = useState("");

  // Es muss immer ein BaseUrl geben
  useEffect(() => {
    if (apiBaseUrl) {
      setUrl1(`${apiBaseUrl}api/getAllUsers`);
      //setUrl2(`${apiBaseUrl}gruppen/listid`);
    }
  }, [apiBaseUrl]);

  const {
    isPending:isPending1,
    error: error1,
    data: allUserData,
  } = useQuery({
    queryKey: [url1 + forceRender],
    queryFn: () => {
      if (url1) {
        // Überprüfen, ob url1 definiert ist
        return fetch(url1, {
          headers: {
            Authorization: `Bearer ${user.bearer}`,
          },
        }).then((res) =>  {
          if (res.status === 401) logoutLogin();
          return res.json();
        });
      } else {
        // Wenn url1 nicht definiert ist, gib ein leeres Objekt zurück oder handle den Fall entsprechend
        return [];//Promise.resolve({});
      }
    },
  });

  useEffect(() => {
    if (allUserData) {
      console.log("XXX allUserData", allUserData);
      const newData = allUserData.map((item, index) => ({
        ...item,
        key: index,
      }));
      setInfoUser({
        userItems: newData,
      });
    }
  }, [allUserData]);

  useEffect(() => {
    setColumnWidth(windowWidth > 1450 ? 85 : 1);
  }, [windowWidth]);

  const handleForceRender = () => {
    console.log("Force render initiated vor Set", forceRender);
    setForceRender((prev) => !prev); // Ändert den Zustand und erzwingt ein erneutes Rendern
  };
  const warning = (info) => {
    messageApi.open({
      type: "warning",
      content: info,
    });
  };
  const clickHandler = (e, rowData) => {
    if (checkRole("Admin")) {
      e.preventDefault();
      console.log("clickHandler geklickt", rowData);
      setRowData(rowData);
      setRedirectToAccount(true);
    } else {
      warning("Oje, das darf nur der Admin");
    }
  };
  /*
  const DeleteConfirmationModal = ({ onConfirmDelete, onCancel, visible }) => {
    return (
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: "#f33",
            //colorBgContainer: "#88ff88",
          },
          components: {
            Modal: {
              titleColor: "#f00",
            },
          },
        }}
      >
        <Modal
          title="Benutzer löschen"
          open={visible}
          onOk={onConfirmDelete}
          onCancel={onCancel}
        >
          <p>
            Möchten Sie diesen Benutzer <b>{userNameToDelete}</b> wirklich
            löschen?
          </p>
        </Modal>
      </ConfigProvider>
    );
  };
  */
  const handleShowModal = () => {
    setModalVisible(true);
  };
  const handleCancelModal = () => {
    // Schließen Sie die Modale Abfrage, wenn der Benutzer sie abbricht
    setModalVisible(false);
  };

  const handleConfirmDelete = async () => {
    setModalVisible(false);
    message.info("Benutzer " + userNameToDelete + " löschen");
    console.log("handleConfirmDelete 2");
    await deleteUser(userNameToDelete, user.bearer);
    console.log("handleConfirmDelete 3");
    handleForceRender();
  };

  const handleConfirmDeleteXX = async () => {
    message.danger("Benutzer löschen");
    // Hier können Sie die Logik für das tatsächliche Löschen des Benutzers implementieren
    // ...
    await deleteUser(rowData.userName, user.bearer);
    handleForceRender();

    // Schließen Sie die Modale Abfrage nach dem Löschen
    setModalVisible(false);
  };
  const clickDeleteHandler = (e, rowData) => {
    if (checkRole("Admin")) {
      e.preventDefault();
      console.log("clickDeleteHandler geklickt", rowData);
      setUserNameToDelete(rowData.userName);
      setModalVisible(true);
    } else {
      warning("Oje, das darf nur der Admin");
    }
  };
  const [infoUser, setInfoUser] = useState({
    //email: "",
    //isEmailConfirmed: false,
    userItems: null,
  });

  /*
  useEffect(() => {
    const fetchData = async () => {
      try {
        const users = await getAllUsers(user.bearer);
        //console.log("Users:",users);
        setInfoUser({
          userItems: users,
        });
      } catch (error) {
        console.error("Fehler beim Abrufen der Benutzerliste", error);
      }
    };
    console.log("Daten neu einlesen mit ");
    fetchData(); // Daten beim Mounten der Komponente abrufen
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.bearer, forceRender]); // Abhängigkeit hinzufügen, um die Funktion bei Änderungen von user.bearer erneut aufzurufen
*/

  console.log("info", infoUser);
  /*
  const UserList = ({ users }) => {
    return (
      <ul>
        {users.map((user) => (
          <li key={user.id}>
            <strong>Email:</strong> {user.userName},&nbsp;
            <strong>Email Confirmed:</strong>{" "}
            {user.emailConfirmed ? "Yes" : "No"}&nbsp;
            <strong>Tel.:</strong> {user.phoneNumber},&nbsp;
            <strong>Tel Confirmed:</strong>{" "}
            {user.phoneNumberConfirmed ? "Yes" : "No"}&nbsp;
            <strong>Failed:</strong> {user.accessFailedCount},&nbsp;
          </li>
        ))}
      </ul>
    );
  };
*/
  // Wenn redirectToAccount true ist, wird die Account-Komponente gerendert
  if (redirectToAccount && rowData) {
    //console.log("redirectToAccount", rowData.userName);
    navigate("/accountEdit?email=" + rowData.userName);
    //return <Account email={rowData.userName} />;
  }

  const [selectionType, setSelectionType] = useState("radio");
  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      console.log(
        `selectedRowKeys: ${selectedRowKeys}`,
        "selectedRows: ",
        selectedRows
      );
    },
    getCheckboxProps: (record) => ({
      disabled: record.name === "Disabled User",
      // Column configuration not to be checked
      name: record.name,
    }),
  };
  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});
  const handleChange = (pagination, filters, sorter) => {
    console.log("Various parameters", pagination, filters, sorter);
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };
  const handleEditButtonClick = (userName) => {
    // Hier kannst du die Logik für den Bearbeitungsbutton umsetzen
    console.log(`Edit button clicked for id ${userName}`);
    if (checkRole("Admin")) {
      //e.preventDefault();
      //console.log("clickHandler geklickt", rowData);
      //setRowData(rowData);
      //setRedirectToAccount(true);
      navigate("/accountEdit?email=" + userName);

      message.info(`Bearbeiten von : ${userName}`);
    } else {
      message.danger("Oje, das darf nur der Admin");
    }
  };
  const handleDeleteButtonClick = (userName) => {
    // Hier kannst du die Logik für den Bearbeitungsbutton umsetzen
    console.log(`Delete button clicked for id ${userName}`);
    if (checkRole("Admin")) {
      //e.preventDefault();
      //console.log("clickHandler geklickt", rowData);
      //setRowData(rowData);
      //setRedirectToAccount(true);
      setUserNameToDelete(userName);
      setModalVisible(true);
      message.info(`Löschen von ID: ${userName}`);
    } else {
      message.danger("Oje, das darf nur der Admin");
    }
  };

  const [pagination, setPagination] = useState({
    pageSize: 10,
    current: 1,
  });
  const getAntOutputTable = (jsonData) => {
    let data = [];
    Object.entries(jsonData).map(([key, value], index) => {
      //console.log(value);
      data.push({
        key: key,
        id: value.id,
        userName: value.userName,
        emailConfirmed: value.emailConfirmed,
        phoneNumber: value.phoneNumber,
        roles: value.roles,
        text0: value.text0,
        text1: value.text1,
        phoneNumberConfirmed: value.phoneNumberConfirmed,
        accessFailedCount: value.accessFailedCount,
        picture: value.picture,
        email: value.email,
      });
    });
    const ProfilePicture = ({ base64Image }) => {
      const src = `data:image/jpeg;base64,${base64Image}`;
      //console.log("XXX  ProfilePicture", base64Image);
      return (
        <>
          <Avatar
            size={64} // Passen Sie die Größe nach Bedarf an
            src={src}
            alt="Avatar"
          />
          {/*<Image src={src} />*/}
        </>
      );
    };

    const columns = [
      {
        title: "Bild",
        dataIndex: "picture",
        key: "picture",
        width: 95,
        render: (picture) => (
          <>{picture && <ProfilePicture base64Image={picture} />}</>
        ),
        //ellipsis: true,
        //fixed: "left",
      },

      {
        title: "Username",
        dataIndex: "userName",
        key: "userName",
        filteredValue: filteredInfo.userNname || null,
        onFilter: (value, record) => record.name.includes(value),
        sorter: (a, b) => a.userName.length - b.userName.length,
        sortOrder:
          sortedInfo.columnKey === "userName" ? sortedInfo.order : null,
        ellipsis: true,
        fixed: "left",
      },

      {
        title: "Details",
        dataIndex: "userName",
        key: "userName",
        width: 100,
        render: (userName) => (
          <>
            {checkRole("Admin") && (
              <Button
                size="small"
                onClick={() => handleEditButtonClick(userName)}
              >
                Bearbeiten
              </Button>
            )}
          </>
        ),
      },
      /*
      {
        title: "id",
        dataIndex: "id",
        key: "id",
        width: columnWidth,
        render: (id) => {
          return (
            <>
              <div
                style={{
                  width: "80px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {id}
              </div>
            </>
          );
        },
      },*/
      {
        title: "Delete",
        dataIndex: "userName",
        key: "userName",
        width: 100,
        render: (userName) => (
          <>
            {checkRole("Admin") && (
              <Button
                size="small"
                danger
                onClick={() => handleDeleteButtonClick(userName)}
              >
                Löschen
              </Button>
            )}
          </>
        ),
      },
      {
        title: "Benutzerrollen",
        dataIndex: "roles",
        key: "roles",
        render: (roles) => <>{roles && roles.join(", ")}</>,
      },
    ];
    const onChange = (pagination, filters, sorter, extra) => {
      console.log("params", pagination, filters, sorter, extra);
    };

    const paginationConfig = {
      pageSize: 8, // Hier die gewünschte Anzahl der Zeilen pro Seite einstellen
      showSizeChanger: false, // Optional: Zeige das Dropdown-Menü zur Auswahl der Zeilenanzahl
      pageSizeOptions: ["5", "10", "20", "30", "40"], // Optional: Anpassbare Optionen für das Dropdown-Menü
      // Weitere Pagination-Konfigurationen können hinzugefügt werden

      onChange: (current, pageSize) => {
        // Hier kannst du die Logik für die Änderung der Seite oder der Zeilenanzahl implementieren
        console.log(`--->Current page: ${current}, Page size: ${pageSize}`);
        setPagination({
          ...pagination,
          current,
          pageSize,
        });
      },
    };
    return (
      <>
        {/*
        <Radio.Group
          onChange={({ target: { value } }) => {
            setSelectionType(value);
          }}
          value={selectionType}
        >
          <Radio value="checkbox">Checkbox</Radio>
          <Radio value="radio">radio</Radio>
        </Radio.Group>

        <Divider />
         */}

        <Table
          pagination={{ ...pagination, ...paginationConfig }}
          rowSelection={{
            type: selectionType,
            ...rowSelection,
          }}
          columns={columns}
          dataSource={data}
          onChange={onChange}
        />
      </>
    );
  };
  /*
  const getOutputTable = (jsonData) => {
    const customStyles = {
      header: {
        style: {
          minHeight: "56px",
        },
      },
      headRow: {
        style: {
          borderTopStyle: "solid",
          borderTopWidth: "1px",
        },
      },
      headCells: {
        style: {
          "&:not(:last-of-type)": {
            borderRightStyle: "solid",
            borderRightWidth: "1px",
          },
        },
      },
      cells: {
        style: {
          "&:not(:last-of-type)": {
            borderRightStyle: "solid",
            borderRightWidth: "1px",
          },
        },
      },
    };
    const columns = [
      {
        cell: (row) => {
          if (checkRole("Admin")) {
            return (
              <Button
                size={"small"}
                block
                style={{ margin: "2px 3px 2px 3px" }}
                onClick={(e) => clickHandler(e, row)}
              >
                Bearbeiten
              </Button>
            );
          } else {
            return "Info"; // Oder eine alternative UI-Komponente oder nichts
          }
        },
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
      },
      {
        cell: (row) => {
          if (checkRole("Admin")) {
            return (
              <Button
                size={"small"}
                block
                danger
                style={{ margin: "2px 3px 2px 3px" }}
                onClick={(e) => clickDeleteHandler(e, row)}
              >
                Löschen
              </Button>
            );
          } else {
            return "Info"; // Oder eine alternative UI-Komponente oder nichts
          }
        },
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
      },
      {
        name: "Benutzername",
        selector: (row) => row.userName,
        sortable: true,
        grow: 2,
        right: false,
      },
      {
        name: "Email Confirmed",
        selector: (row) => (row.emailConfirmed ? "Yes" : "No"),
        sortable: true,
        grow: 2,
      },
      {
        name: "Telefon",
        selector: (row) => row.phoneNumber,
        sortable: true,
        grow: 2,
      },
      {
        name: "Tel. Confirmed",
        selector: (row) => (row.phoneNumberConfirmed ? "Yes" : "No"),
        sortable: true,
        grow: 2,
      },
      {
        name: "Error",
        selector: (row) => row.accessFailedCount,
        sortable: true,
        grow: 2,
      },
      {
        name: "Id",
        selector: (row) => row.id,
        sortable: false,
        grow: 1,
      },
    ];
    const data = [];
    Object.entries(jsonData).map(([key, value], index) =>
      data.push({
        key: key,
        id: value.id,
        userName: value.userName,
        emailConfirmed: value.emailConfirmed,
        phoneNumber: value.phoneNumber,
        phoneNumberConfirmed: value.phoneNumberConfirmed,
        accessFailedCount: value.accessFailedCount,
      })
    );
    return (
      <DataTable
        columns={columns}
        data={data}
        //pagination
        dense
        customStyles={customStyles}
        //columns={columns(this.handleButtonClick)}
        //onSelectedRowsChange={this.handleChange}
        title="Alle am Server registrierten Benutzer"
        selectableRows
      />
    );
  };
  */
  //message.info("Reder AlleUser");
  return (
    <div className="page">
      {contextHolder}
      <DeleteConfirmationModal
        title="Benutzer löschen"
        text={
          <>
            Möchten Sie diesen Benutzer <b>{userNameToDelete}</b> wirklich
            löschen?
          </>
        }
        visible={modalVisible}
        onConfirmDelete={handleConfirmDelete}
        onCancel={handleCancelModal}
      />
      <ConfigProvider
        theme={{
          components: {
            Button: {
              defaultHoverBg: "#eee",
              paddingInlineLG: 5,
            },
          },
        }}
      >
        {infoUser.userItems && getAntOutputTable(infoUser.userItems)}
      </ConfigProvider>

      {/* 
      <h1>Benutzerliste</h1>
      {infoUser.userItems && <UserList users={infoUser.userItems} />}
      */}
      <PendingComp isPending={isPending1} />
    </div>
  );
};
/*//{infoUser.userItems && getOutputTable(infoUser.userItems)} */
